if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.loadContent = this.loadContent.bind(this);
      this.onClose = () => this.unloadContent(true);
    }

    connectedCallback() {
      this.eventsController?.abort();
      this.eventsController = new AbortController();
      const options = { signal: this.eventsController.signal };
      this.button = this.querySelector('.product-single__media-model-button');
      this.slider = this.closest('product-slider');
      this.button?.addEventListener('click', this.loadContent, options);
      this.parentNode?.querySelector('.product-single__media-xr-close')?.addEventListener('click', this.onClose, options);
    }

    disconnectedCallback() {
      this.eventsController?.abort();
      this.unloadContent();
    }

    loadContent() {
      if (!this.isConnected || this.hasAttribute('loaded')) return;
      const source = this.querySelector('template')?.content.querySelector('model-viewer');
      if (!source || typeof window.Shopify?.loadFeatures !== 'function') return;
      const model = this.appendChild(source.cloneNode(true));
      this.setAttribute('loaded', true);
      model.focus();
      this.slider?.classList.add('dots--disabled');
      if (this.slider?.flkty) this.slider.setDraggable(false);
      this.sliderLocked = true;
      try {
        Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: (errors) => this.setupModelViewerUI(errors, model),
        },]);
      } catch (error) {
        this.unloadContent(true);
      }
    }
    unloadContent(restoreFocus = false) {
      const ui = this.modelViewerUI;
      this.modelViewerUI = null;
      try {
        ui?.destroy?.();
      } catch (error) {
        // Aunque falle la limpieza del SDK, liberar el carrusel y permitir reintentar.
      } finally {
        this.querySelector('model-viewer')?.remove();
        if (this.sliderLocked) {
          if (this.slider?.isConnected && this.slider.flkty) this.slider.setDraggable(true);
          this.slider?.classList.remove('dots--disabled');
          this.sliderLocked = false;
        }
        this.removeAttribute('loaded');
        if (restoreFocus && this.isConnected) this.button?.focus();
      }
    }
    setupModelViewerUI(errors, model) {
      // Una apertura anterior no puede inicializar el modelo nuevo ni el ya cerrado.
      if (!this.isConnected || !this.hasAttribute('loaded') || this.querySelector('model-viewer') !== model || this.modelViewerUI) return;
      if (errors || typeof window.Shopify?.ModelViewerUI !== 'function') {
        this.unloadContent(true);
        return;
      }
      try {
        this.modelViewerUI = new Shopify.ModelViewerUI(model);
      } catch (error) {
        this.unloadContent(true);
      }
    }
  });
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },]);
  },
  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) {
    window.ProductModel.loadShopifyXR();
  }
});
